/**
 * After an update, a tab opened before it still asks for the old build's
 * screen files, which no longer exist (3 Oct walk: Studio rebuilt at 11:23,
 * an older tab couldn't open any other screen and showed nothing).
 *
 * The fix: reload once, quietly, to pick up the new version. If that
 * already happened in the last minute, don't loop: the crash screens show
 * "Studio has been updated" with a Reload button instead.
 */
const KEY = 'fp-stale-reload-at';

export function isStaleBuildError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err ?? '');
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(msg);
}

/** Reload for the new version, unless we just did. True when reloading. */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // No storage (private window): reload anyway; a loop is still bounded by the error screen.
  }
  window.location.reload();
  return true;
}

/** For lazy screens: a stale-build failure reloads instead of crashing. */
export function importOrReload<T>(load: () => Promise<T>): () => Promise<T> {
  return () => load().catch((err) => {
    if (isStaleBuildError(err) && reloadForNewVersion()) return new Promise<T>(() => {});
    throw err;
  });
}
